// React and core libraries
import * as React from "react";

// UI components
import { SelectWithLabel } from "../../../components/system/select-with-label";
import {
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../../../components/ui/select";

type ClusterAlertFilterProps = {
  value: number;
  setValue: (val?: number) => void;
};

export const ClusterAlertLevelFilter = ({
  value,
  setValue,
}: ClusterAlertFilterProps): React.ReactElement => {
  return (
    <SelectWithLabel
      label="Min Alert Level"
      value={value.toString()}
      onValueChange={(val: string) => setValue(Number(val))}
    >
      <SelectTrigger className="w-full md:w-[120px]">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="40">Error</SelectItem>
        <SelectItem value="30">Warning</SelectItem>
        <SelectItem value="20">Info</SelectItem>
        <SelectItem value="10">Debug</SelectItem>
        <SelectItem value="0">Show All</SelectItem>
      </SelectContent>
    </SelectWithLabel>
  );
};
